module.exports = __webpack_public_path__ + "static/img/limao-zero.f1c257a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/limao-zero.png
// module id = Aq8p
// module chunks = 0